module.exports = __webpack_public_path__ + "3d6897d0f91aa4917ca43bf14a1f1f28.png";


//////////////////
// WEBPACK FOOTER
// ./public/pic_about_3@2x.png
// module id = 218
// module chunks = 1